import {Injectable} from '@angular/core';
import {BaseApiService} from './base-api.service';
import {ICart} from '../../types/ICart';
import {ICartSession, ICartSessionResponse} from '../../types/ICartSession';
import {IPriceLevel} from '../../types/IPriceLevel';
import {map} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartService extends BaseApiService {
  getCartSession(session_id: string) {
    return this.get<ICartSessionResponse>(`cart-sessions/${session_id}`).pipe(
      map((response): ICartSession => {
        const {cart: rawCart, permissions, capabilities} = response.data;
        const {client, ...cart} = rawCart;

        return {
          cart: {...cart, client_id: client.public_id} as ICart,
          client_id: client.public_id,
          location: {
            name: client.name,
            phone: client.phone,
            email: client.email,
            address: client.address,
            city: client.city,
            state: client.state,
            zip: client.zip,
          },
          permissions,
          capabilities,
        };
      })
    );
  }

  getPriceLevels(client_id: string) {
    return this.get<{data: {levels: [IPriceLevel]}}>(`clients/${client_id}/pricing/levels`).pipe(
      map(response => response.data.levels)
    );
  }
}
